export const Promotional = {
    RelationalFinder: {
        Name: "RelationFinder",
        Threshold: 5,
        Reference: 7
    },
    Website : {
        Name: "Website",
        Threshold: 15,
        Reference: 8
    },
    Donation: {
        Name: "Donation",
        Threshold: 20,
        Reference: 10
    }
}